export default [{
  path: '/dashboard-slides/:profileId/:profile/:dash01/:dash02',
  name: 'DashboadSlides',
  component: () => import('./DashboadSlides'),
  meta: {
    resource: 'dashboard',
    actions: ['read']
  }
}]
